import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared.service';
import swal from 'sweetalert';
import { createEmitAndSemanticDiagnosticsBuilderProgram } from 'typescript';
import { start } from 'node:repl';
@Component({
  selector: 'app-change-request',
  templateUrl: './change-request.component.html',
  styleUrls: ['./change-request.component.scss']
})
export class ChangeRequestComponent implements OnInit {
  constructor(private service: SharedService) { }
  requestList: any = [];
  employeeList: any = [];
  pendingList: any = [];
  acceptedList: any = [];
  rejectedList: any = [];
  empId!: number;
  employee: any;
  tasks: any = [];
  taskList: any = [];
  ngOnInit(): void {
    this.service.currentEmployee.subscribe(data => {
      this.employee = data
      this.empId = this.employee.pkEmpId;
    });
    this.GetEmployeeList();
    this.RefreshRequestList();
  }
  async Test() {
    var startDate = new Date(this.requestList[0].Date + "Z").toISOString().split('T')[0] + 'T00:00:00Z';
    console.log(startDate);
    var endDate = new Date(this.requestList[0].Date + "Z").toISOString().split('T')[0] + 'T23:59:00Z';
    console.log(endDate);
    console.log(this.employee);
    this.service.GetClockifyContacts(this.employee[0].ClockifyId, startDate, endDate).subscribe(data => {
      console.log(data)
    });
  }
  // GetEmployee(id: number)
  // {
  //   this.employee = this.employeeList.find((emp: { pkEmpId: number; }) => emp.pkEmpId === id);
  // }
  GetEmployee(empId: number) {
    this.service.GetEmployee(empId).subscribe(data => {
      this.employee = data
    });
  }
  GetEmployeeList() {
    this.service.GetEmpList().toPromise().then(data => {
      this.employeeList = data
    });
  }
  RefreshRequestList() {
    this.service.GetAllRequests().toPromise().then(data => {
      this.requestList = data;
      this.SplitRequestList();
    });
  }
  SplitRequestList() {
    this.pendingList = [];
    this.acceptedList = [];
    this.rejectedList = [];
    for (var request of this.requestList) {
      if (request.Status == 'Pending') {
        this.pendingList.push(request);
      }
      else if (request.Status == 'Accepted') {
        this.acceptedList.push(request);
      }
      else if (request.Status == 'Rejected') {
        this.rejectedList.push(request);
      }
    }
  }
  GetAdminName(request: any) {
    var admin = this.employeeList.find((emp: { pkEmpId: number; }) => emp.pkEmpId === request.fkAdminId)
    var name = admin?.FirstName + ' ' + admin?.LastName;
    return name
  }
  GetRequesterName(request: any) {
    var emp = this.employeeList.find((emp: { pkEmpId: any; }) => emp.pkEmpId === request.fkEmpId)
    var name = emp?.FirstName + ' ' + emp?.LastName;
    return name
  }
  DenyRequest(request: any) {
    if (request.Type == "Type" || request.Type == "Time") {
      this.RejectRequest(request);
    }
  }
  AcceptRequest(request: any) {
    if (request.Type == "Type") {
      this.AcceptTypeRequest(request);
    }
    else if (request.Type == "Time") {
      this.AcceptTimeRequest(request);
    }
  }
  AcceptTypeRequest(request: any) {
    var leave =
    {
      fkEmpId: request.fkEmpId,
      Date: request.Date,
      Type: request.RequestedValue
    }
    swal
      ({
        title: "Are you sure?",
        text: "Approving this request can not be undone",
        icon: "info",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
        dangerMode: true,
      })
      .then((confirm) => {
        if (confirm) {
          this.service.ChangeLeaveType(leave).subscribe(data => {
            console.log(data);
          });
          request.DateReviewed = new Date().toISOString().split('T')[0];
          request.fkAdminId = this.empId;
          request.Status = "Accepted";
          this.service.UpdateChangeRequest(request).subscribe(data => {
            console.log(data);
          });
          swal("SUCCESS", "Request has been approved", "success")
            .then(() => {
              this.ngOnInit();
            })
        }
      });
  }
  RejectRequest(request: any) {
    swal
      ({
        title: "Are you sure?",
        text: "Denying this request can not be undone",
        icon: "info",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
        dangerMode: true,
      })
      .then((confirm) => {
        if (confirm) {
          request.DateReviewed = new Date().toISOString().split('T')[0];
          request.fkAdminId = this.empId;
          request.Status = "Rejected";
          this.service.UpdateChangeRequest(request).subscribe(data => {
            console.log(data);
          });
          swal("SUCCESS", "Request has been denied", "success")
            .then(() => {
              this.ngOnInit();
            })
        }
      });
  }
  AcceptTimeRequest(request: any) {
    swal
      ({
        title: "Are you sure?",
        text: "Approving this request will import data from clockify and cannot be undone",
        icon: "info",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
        dangerMode: true,
      })
      .then((confirm) => {
        if (confirm) {
          this.GetClockifyforOneEmpOneDay(request);
          request.DateReviewed = new Date().toISOString().split('T')[0];
          request.fkAdminId = this.empId;
          request.Status = "Accepted";
          this.service.UpdateChangeRequest(request).subscribe(data => {
            console.log(data);
          });
          // swal("SUCCESS", "Request has been approved", "success")
          // .then(()=>
          // {
          //   this.ngOnInit();
          // })
        }
      });
  }
  async GetClockifyforOneEmpOneDay(request: any) {
    var startDate = new Date(request.Date + "Z").toISOString().split('T')[0] + 'T00:00:00Z';
    var endDate = new Date(request.Date + "Z").toISOString().split('T')[0] + 'T23:59:00Z';
    this.service.DeleteTaskBeforeImport(this.employee[0].ClockifyId, request.Date).subscribe(data => {
      console.log(data);
    });
    this.service.DeleteClockifyBeforeImport(this.employee[0].ClockifyId, request.Date).subscribe(data => {
      console.log(data);
    });
    await new Promise(resolve => this.service.
      GetClockifyContacts(this.employee[0].ClockifyId, startDate, endDate).subscribe(data => {
        this.tasks = data;   //contact list contains 20 keys wanted to retain only 6 keys
        resolve(data)
        for (let i = 0; i < this.tasks.length; i++) {
          let task =
          {
            pkTaskId: this.tasks[i]['id'],
            Project: this.tasks[i]['projectId'],
            ClockifyId: this.tasks[i]['userId'],
            Description: this.tasks[i]['description'],
            StartTime: this.tasks[i]['timeInterval']['start'],
            EndTime: this.tasks[i]['timeInterval']['end'],
            Date: this.tasks[i]['timeInterval']['start'],
            Duration: this.tasks[i]['timeInterval']['duration']
          }
          this.taskList.push(task);
        }
      }));
    this.PostClockify();
  }
  async PostClockify() {
    for (let i = 0; i < this.taskList.length; i++) {
      await new Promise(resolve => this.service.PostClockifyContacts(this.taskList[i]).subscribe(data => {
        resolve(data)
        console.log("Data Saved Successfully");
      },
        error => {
          console.log("Data Not Saved Suceesfully");
        }));
    }
    this.FilterClockify()
  }
  async FilterClockify() {
    await new Promise(resolve => this.service.PostClockifyFilter().subscribe(data => {
      swal("SUCCESS", "Request has been approved", "success")
        .then(() => {
          this.ngOnInit();
        })
      resolve(data)
    },
      error => {
        swal("ERROR", "Request approval failed", "failure")
          .then(() => {
            this.ngOnInit();
          })
      }));
  }
}
